<template lang="pug">

  section.headerbrand
    h3 Presentado por
      img.logo(:src="brand.image", :alt="brand.title")

</template>

<script>

  export default  {
    name: 'headerbrand',
    props: {
      brand: {
        type: Object,
        default: function() {
          return {
            title: 'La Tercera',
            image: 'assets/images/logos/latercera.svg'
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .headerbrand {
    border-top: 1px solid #eaeaea;
    border-bottom: 1px solid #eaeaea;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0.5rem 0;
    h3{
      display: flex;
      align-items: center;
      justify-content: center;
      color: #1b3043;
      @include fluid-type(360px, 1440px, 10px, 13.5px);
      text-decoration: none;
      text-transform: uppercase;
      transition: all .3s ease;
      font-family: 'Open Sans', sans-serif;
      -webkit-font-smoothing: antialiased;
      img{
        padding-left: 0.5rem;
        max-height: 25px;
      }
    }
  }
</style>
